import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { SpezifikationEntity } from '../../../entities/mdqx/spezifikation.entity';
import { SpezifikationActions, SpezifikationActionTypes } from '../../actions/mdqx/spezifikation.actions';

export interface SpezifikationState extends EntityState<SpezifikationEntity> {
    fetched: boolean;
}

export const SPEZIFIKATION_KEY = 'spezifikation';

const adapter = createEntityAdapter<SpezifikationEntity>({
    selectId: spezifikation => spezifikation.Id,
});

const initialState: SpezifikationState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function spezifikationReducer(state = initialState, action: SpezifikationActions) {
    switch (action.type) {
        case SpezifikationActionTypes.GetSpezifikationenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllSpezifikationen = selectAll;

export const selectSpezifikationenFetched = (state: SpezifikationState) => state.fetched;
